import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 30, // cache 30 segundos,
      gcTime: 1000 * 60 * 30,
      retry: false,
    },
  },
});
